$ = require 'jquery'
_ = require 'underscore'
Auth = require 'db/auth'
BoardPowerUpItemView = require 'views/board-menu/board-power-up-item-view'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
Format = require 'lib/markdown/format'
f = require 'effing'
l = require 'lib/localize'
NewPowerUps = require 'data/new-power-ups'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PluginAuthorizedView = require 'views/board-menu/plugin-settings-view'
PluginDetailsView = require 'views/plugin/plugin-details-view'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
simpleTest = require 'lib/experiments/simple-test'
t = require('views/internal/teacup-with-helpers')('plugin_item')
trackUe = require 'debug/trackUe'
xtend = require 'xtend'
ClientConfig = require 'debug/client-config'

powerUpItemTemplateWithTaglines = ({ loading, name, iconUrl, description, canEnable, supportsSettings, supportsAuth, hasPersonalSettings, upgradeUrl, upsellEnabled }) ->
  t.div '.power-up-item-header', ->
    t.div '.power-up-item-icon', ->
      if iconUrl
        t.img '.power-up-item-icon-image.plugin-item-icon', { src: iconUrl, alt: name }
      t.span '.power-up-item-new-icon', ->
        t.format 'new'


    t.div '.power-up-item-details', ->
      t.h4 '.power-up-item-details-header.js-show-details', ->
        if loading
          t.format 'loading'
        else if name
          t.text name
        else
          t.format 'unknown plugin'

    t.div '.power-up-item-actions', ->

      if canEnable
        if hasPersonalSettings || supportsSettings || supportsAuth
          t.a '.power-up-item-actions-button.mod-settings.js-show-settings', { href: '#' }, ->
            t.icon 'gear'
        if upsellEnabled
          if upgradeUrl
            t.a '.power-up-item-actions-button.mod-upgrade.button-link', { href: upgradeUrl }, ->
              t.format 'upgrade'
          else
            t.a '.power-up-item-actions-button.mod-upgrade.button-link.js-add-to-team', { href: '#' }, ->
              t.format 'upgrade'

        t.a '.power-up-item-actions-button.mod-enable.button-link.primary.js-enable', { href: '#' }, ->
          t.format 'enable'

        t.a '.power-up-item-actions-button.mod-disable.button-link.negate.js-disable', { href: '#' }, ->
          t.format 'disable'

        t.a '.power-up-item-actions-button.mod-fake-enable.button-link.primary.js-fake-enable', { href: '#' }, ->
          t.format 'enable'

  t.div '.power-up-item-tagline.js-show-details', ->
    t.text getTagline(description)

defaultPowerUpItemTemplate = ({ loading, name, iconUrl, canEnable, supportsSettings, supportsAuth, hasPersonalSettings, upgradeUrl, upsellEnabled }) ->
  t.div '.power-up-item-icon', ->
    if iconUrl
      t.img '.power-up-item-icon-image.plugin-item-icon', { src: iconUrl, alt: name }
    t.icon 'check', { class: 'power-up-item-enabled-icon' }
    t.span '.power-up-item-new-icon', ->
      t.format 'new'


  t.div '.power-up-item-details', ->
    t.h4 '.power-up-item-details-header.js-show-details', ->
      if loading
        t.format 'loading'
      else if name
        t.text name
      else
        t.format 'unknown plugin'
      t.icon 'information', { class: 'power-up-item-details-info-icon' }

  t.div '.power-up-item-actions', ->

    if canEnable
      if hasPersonalSettings || supportsSettings || supportsAuth
        t.a '.power-up-item-actions-button.mod-settings.button-link.js-show-settings', { href: '#' }, ->
          t.icon 'gear'
      if upsellEnabled
        if upgradeUrl
          t.a '.power-up-item-actions-button.mod-upgrade.button-link', { href: upgradeUrl }, ->
            t.format 'upgrade'
        else
          t.a '.power-up-item-actions-button.mod-upgrade.button-link.js-add-to-team', { href: '#' }, ->
            t.format 'upgrade'

      t.a '.power-up-item-actions-button.mod-enable.button-link.js-enable', { href: '#' }, ->
        t.format 'enable'

      t.a '.power-up-item-actions-button.mod-disable.button-link.js-disable', { href: '#' }, ->
        t.format 'disable'
      if upsellEnabled
        t.a '.power-up-item-actions-button.mod-fake-enable.button-link.js-fake-enable', { href: '#' }, ->
          t.format 'enable'

template = t.renderable ({ loading, name, iconUrl, description, source, canEnable, supportsSettings, supportsAuth, hasPersonalSettings, upgradeUrl, upsellEnabled }) ->
  data = { loading, name, iconUrl, description, source, canEnable, supportsSettings, supportsAuth, hasPersonalSettings, upgradeUrl, upsellEnabled }

  if simpleTest('powerUpTaglines')?.get('showTaglines')
    return powerUpItemTemplateWithTaglines(data)

  return defaultPowerUpItemTemplate(data)

getTagline = (powerUpDetails) ->
  powerUpDetailsRawText = $(Format.markdownAsHtml(powerUpDetails)).text()
  firstSentence = powerUpDetailsRawText.split(/\.\s|\.{3}|…/, 1)[0].trim()

  return "#{firstSentence.substring(0, 95).trim()}…"

module.exports = class BoardPluginItemView extends BoardPowerUpItemView
  initialize: ({ @plugin }) ->
    @io = PluginIOCache.get(@plugin)

    @initialData =
      loading: true
      canEnable: @model.editable()
      upgradeUrl:
        if @model.hasOrganization()
          Controller.getBoardPowerUpsUpgradeUrl(@model)
      upsellEnabled: !ClientConfig.get('dontUpsell')


    @listenTo @model, 'change:powerUps', @frameDebounce @renderEnabledState
    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @renderEnabledState
    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @frameDebounce @renderEnabledState

    return

  renderOnce: ->
    @$el.html template(@initialData)

    @renderPluginData()
    @renderEnabledState()

    @

  renderPluginData: ->
    Promise.props
      loading: false
      name: @io.getName()
      description: @io.getDescription()
      iconUrl: @io.getIconUrl()
      hasPersonalSettings: @hasPersonalSettings()
      supportsAuth: @io.supports('show-authorization')
      supportsSettings: @io.supports('show-settings')
    .then (data) =>
      @$el.html template(xtend(@initialData, data))
      @subscribe @model.boardPluginList.snoop(), @renderEnabledState
    .done()

    @

  getEnabledState: ->
    @model.isPluginEnabled(@plugin.id)

  renderEnabledState: ->
    isEnabled = @getEnabledState()
    canEnableAdditional = @model.canEnableAdditionalPowerUps()
    hasDismissedAd = Auth.me().isDismissed("PowerUpsLimitFullAd")
    isNew =
      NewPowerUps.hasOwnProperty(@plugin.id) &&
      NewPowerUps[@plugin.id] > Date.now() - 14 * 24 * 60 * 60 * 1000

    @$el.toggleClass('is-enabled', isEnabled)
    @$el.toggleClass('is-new', isNew)
    @$el.toggleClass('needs-upgrade', !isEnabled && !canEnableAdditional && hasDismissedAd)
    @$el.toggleClass('fake-enable', !isEnabled && !canEnableAdditional && !hasDismissedAd)
    @

  hasPersonalSettings: ->
    pluginData = _.extend Auth.me().getPluginData(@io.id), @model.getPluginData(@io.id)
    _.any pluginData, ({ private: privateData }) -> privateData?

  enable: ->
    @model.enablePlugin(@plugin.id)
    trackUe('Power-Up listing', 'enables', 'Power-Up', '', '', 'enable button', @plugin.id)
    return

  disable: ->
    @model.disablePlugin(@plugin.id)
    trackUe('Power-Up listing', 'disables', 'Power-Up', '', '', 'disable button', @plugin.id)
    return

  showDetails: (elem) ->
    board = @model
    io = PluginIOCache.get(@plugin)
    PopOver.toggle
      elem: elem
      getViewTitle: f io, 'getName'
      reactElement: React.createElement PluginDetailsView, { io: io, model: board, key: @plugin.id }

    trackUe('Power-Up listing', 'opens', 'Power-Up', '', '', 'show-details', @plugin.id)
    return


  # Say to the plugin "show settings with this element as a PopOver.elem"
  showSettings: (elem) ->
    io = PluginIOCache.get(@plugin)

    # Close the popover if it's open for this element already
    if PopOver.toggledBy(elem)
      PopOver.hide()
      return

    trackUe('Power-Up listing', 'opens', 'Power-Up', '', '', 'show-settings', @plugin.id)

    Promise.props
      supportsAuth: @io.supports('show-authorization')
      supportsSettings: @io.supports('show-settings')
      hasPersonalSettings: @hasPersonalSettings()
    .then (data) =>
      if data.supportsAuth
        return PluginRunner.one
          timeout: 1000
          plugin: @plugin
          command: 'authorization-status'
          board: @model
        .then (authStatus) ->
          xtend data, { authStatus: authStatus }
      else
        return Promise.resolve(data)
    .then (data) =>
      # Bind an action to this and partially apply elem
      bindElemAction = (action) => _.bind(action, @, elem)
      PopOver.toggle
        elem: elem
        getViewTitle: -> l(['view title', 'powerup settings'], { name: io.getName() })
        reactElement: React.createElement PluginAuthorizedView, xtend data,
          {
            plugin: @plugin
            key: @io.id
            authorize: bindElemAction(@showAuthorization)
            removeData: bindElemAction(@clearData)
            showSettings: bindElemAction(@showPluginSettings)
          }
    return

  showAuthorization: (elem) ->
    trackUe('Power-Up listing', 'opens', 'Power-Up', '', '', 'show-authorization', @plugin.id)
    PluginRunner.one
      plugin: @plugin
      command: 'show-authorization'
      board: @model
      el: elem
    .done()
    return

  showPluginSettings: (elem) ->
    trackUe('Power-Up listing', 'opens', 'Power-Up', '', '', 'edit-settings', @plugin.id)
    PluginRunner.one
      plugin: @plugin
      command: 'show-settings'
      board: @model
      el: elem
    .done()
    return

  clearData: (elem) ->
    Confirm.pushView 'clear plugin data',
      elem: elem
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.clearPluginData(@io.id)
        Auth.me().clearPluginData(@io.id)
        trackUe('Power-Up listing', 'clicks', 'Power-Up', '', '', 'remove-data', @plugin.id)
        @renderPluginData()
        if @io.supports('remove-data')
          return PluginRunner.one
            plugin: @plugin
            command: 'remove-data'
        else
          return
    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-plugin-item-view.coffee